var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.initialised
        ? _c(
            "div",
            [
              _vm.log
                ? [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("h1", { staticClass: "text-primary no-margin" }, [
                          _vm._v(
                            _vm._s(_vm.$t("veneerLog")) + " " + _vm._s(_vm.name)
                          )
                        ]),
                        _vm._v(" "),
                        _c("h2", { staticClass: "q-mt-none q-mb-lg" }, [
                          _vm._v(_vm._s(_vm.speciesName))
                        ]),
                        _vm._v(" "),
                        _vm.unavailable
                          ? _c("p", { staticClass: "text-secondary" }, [
                              _vm._v(_vm._s(_vm.$t("logUnavailable.long")))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isWatchlistItem &&
                        _vm.watchlistItem &&
                        _vm.watchlistItem.price
                          ? _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("label.price")) +
                                  ": " +
                                  _vm._s(
                                    _vm._f("currency")(_vm.watchlistItem.price)
                                  )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isWatchlistItem &&
                        _vm.watchlistItem &&
                        _vm.watchlistItem.description
                          ? _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("label.comment")) +
                                  ": " +
                                  _vm._s(_vm.watchlistItem.description)
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-6" },
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { spread: "" } },
                            [
                              _c("q-btn", {
                                attrs: {
                                  label: _vm.$t("button.measurementList"),
                                  color: "primary",
                                  icon:
                                    "img:\\typo3conf\\ext\\ig_warehouse\\Resources\\Public\\Icons\\tally-sheet.png",
                                  "no-caps": "",
                                  outline: ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showMeasurementListDialog(
                                      _vm.log,
                                      _vm.isVirtual
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.user
                                ? _c("q-btn", {
                                    attrs: {
                                      label: _vm.$t("button.watch"),
                                      color: "primary",
                                      icon: "star_border",
                                      "no-caps": "",
                                      outline: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showWatchlistDialog(
                                          _vm.log,
                                          _vm.isVirtual
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.log.uid && _vm.smallImages
                                ? _c("q-btn", {
                                    attrs: {
                                      label: _vm.$t("button.downloadImages"),
                                      color: "primary",
                                      icon: "cloud_download",
                                      "no-caps": "",
                                      outline: ""
                                    },
                                    on: { click: _vm.downloadImages }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.hideBackLink && _vm.detailViewBackLink
                                ? _c("q-btn", {
                                    attrs: {
                                      to: _vm.detailViewBackLink,
                                      label: _vm.$t("button.back"),
                                      color: "primary",
                                      icon: "arrow_back",
                                      "no-caps": "",
                                      outline: ""
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.previousLogLink
                            ? _c("q-btn", {
                                attrs: {
                                  to: _vm.previousLogLink,
                                  label: _vm.$t("button.previousLog")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.nextLogLink
                            ? _c("q-btn", {
                                attrs: {
                                  to: _vm.nextLogLink,
                                  label: _vm.$t("button.nextLog"),
                                  loading: _vm.loadingLogs
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.showBundleViewer
                      ? _c("bundle-viewer", {
                          staticClass: "q-my-lg",
                          attrs: {
                            log: _vm.log,
                            height: 800,
                            zoomable: true,
                            fullscreen: true,
                            scala: true,
                            isVirtual: _vm.isVirtual
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "q-card",
                      {
                        staticClass: "q-my-md bg-grey-4",
                        attrs: { square: "", flat: "" }
                      },
                      [
                        _c("veneer-log-info", {
                          staticClass: "q-pa-md",
                          attrs: { log: _vm.log, "is-public": _vm.isPublic }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("veneer-log-images", {
                      attrs: { images: _vm.smallImages, large: "" }
                    })
                  ]
                : [
                    _vm._v(
                      "\n\t\t\tFurnierblock kann nicht angezeigt werden.\n\t\t"
                    )
                  ]
            ],
            2
          )
        : _c("q-spinner-cube", {
            staticClass: "absolute-center",
            attrs: { color: "primary", size: "5em" }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }